import { ReferenceField, ReferenceFieldProps } from 'react-admin';

import { TypedField } from 'shared/interfaces/react-admin/typed-field';

import { HasCustomerSource } from '../../interfaces/HasCustomerSource';

export const CustomerReferenceField = ReferenceField as TypedField<
  ReferenceFieldProps & HasCustomerSource
>;
